
import { dateHelper } from '@/helpers/dateHelper'
import { intlFormat } from 'date-fns'
import Vue from 'vue'

export default Vue.extend({
  name: 'appointment-card',
  props: {
    carrier: {
      type: Object as () => { logo: string; name: string },
      required: true,
    },
    selectedSlotTitle: {
      type: String,
      required: true,
    },
    selectedSlot: {
      type: Object as () => { start: string; end: string },
      required: true,
    },
    actionText: {
      type: String,
      default: '',
    },
    showAction: {
      type: Boolean,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
  },
  computed: {
    getDay(): string {
      if (!this.$props.selectedSlot || !this.$props.selectedSlot.start) {
        return this.$t('appointment.confirmationPage.loading')
      }
      const selectedDate = dateHelper.getDate(this.$props.selectedSlot.start)

      if (isNaN(selectedDate.getTime())) {
        return this.$t('appointment.confirmationPage.invalidDate')
      }
      return intlFormat(
        selectedDate,
        {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        },
        {
          locale: this.language,
        },
      )
    },
    getSlot(): string {
      // Protection contre selectedSlot null
      if (
        !this.$props.selectedSlot ||
        !this.$props.selectedSlot.start ||
        !this.$props.selectedSlot.end
      ) {
        return this.$t('appointment.confirmationPage.loading')
      }

      try {
        const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

        const startDate = dateHelper.getDate(this.$props.selectedSlot.start)
        const endDate = dateHelper.getDate(this.$props.selectedSlot.end)

        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
          return this.$t('appointment.confirmationPage.invalidHours')
        }

        const startTime = startDate.toLocaleTimeString(this.language, {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: clientTimezone,
        })
        const endTime = endDate.toLocaleTimeString(this.language, {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: clientTimezone,
        })

        return `${startTime} - ${endTime}`
      } catch (error) {
        return this.$t('appointment.confirmationPage.formattingError')
      }
    },
  },
})
